//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

// Element ids the panel chrome puts in the document, in a leaf module so the
// host can find a panel without importing the component that renders it.

/**
 * A panel's dialog element, which the host asks about when deciding whether
 * focus was orphaned by the panel going away.
 */
export const panelElementId = (id: string): string => `panel-${id}`;

/**
 * A panel's launcher pill, where a dismissal hands focus when no invoker was
 * recorded -- a session-restored panel has no gesture behind it, and a
 * recorded invoker does not survive the header remounting on a route change.
 */
export const panelLauncherId = (id: string): string => `panel-launcher-${id}`;

/**
 * The taskbar pill of a tool that is not a panel, for a tour that must point
 * at it. Beside its sibling so the two cannot be read as unrelated: a tool
 * that becomes a panel moves from one to the other.
 */
export const toolLauncherId = (id: string): string => `tool-launcher-${id}`;
